import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../../context/AuthProvider';
import {
  useCreateMessageMutation,
  useCreateThreadMutation,
  useGetThreadQuery,
  useGetThreadsByAssistantQuery,
} from '../../../../generated/graphqlModels';

const useThread = (
  assistantId?: string,
  blockId?: string,
  preferedThreadId?: string,
) => {
  const user = useContext(AuthContext);
  const [selectedThreadId, setSelectedThreadId] = useState<string | null>(null);

  const { data: threadsByAssistant, loading: loadingThreadsByAssistant } =
    useGetThreadsByAssistantQuery({
      variables: { assistantId: assistantId!, userId: user!.pk },
      skip: !assistantId || !user,
    });

  const { data: threadData, loading: loadingThread } = useGetThreadQuery({
    variables: {
      threadId: selectedThreadId!,
    },
    skip: !selectedThreadId,
  });

  const [createThread, { loading: loadingCreateThread }] =
    useCreateThreadMutation();

  const [createMessage, { loading: isCreatingMessage }] =
    useCreateMessageMutation();

  useEffect(() => {
    if (!assistantId) {
      return;
    }
    if (threadsByAssistant) {
      const threadByAssistant = blockId
        ? threadsByAssistant.threads.find((t) => t.block === blockId)
        : threadsByAssistant.threads.find((t) => t.id === preferedThreadId) ||
          threadsByAssistant.threads.filter((t) => !t.block).at(-1);
      if (threadByAssistant) {
        setSelectedThreadId(threadByAssistant.id);
      } else {
        createNewThread().then();
      }
    }
  }, [threadsByAssistant]);

  const createNewThread = async () => {
    if (!assistantId) {
      return;
    }
    const data = await createThread({
      variables: {
        assistantId,
        ...((blockId && { blockId }) || null),
      },
    });
    const threadId = data.data?.createThread.id;
    if (threadId) {
      setSelectedThreadId(threadId);
    }
  };

  const clearThread = async () => {
    await createNewThread();
  };

  const sendMessage = (content: string) => {
    if (!selectedThreadId) {
      return;
    }
    createMessage({
      variables: {
        content,
        threadId: selectedThreadId,
      },
    });
  };

  const switchThread = (threadId: string) => {
    setSelectedThreadId(threadId);
  };

  return {
    sendMessage,
    clearThread,
    isCreatingMessage,
    thread: threadData?.thread,
    isLoading:
      loadingThreadsByAssistant || loadingCreateThread || loadingThread,
    switchThread,
  };
};

export default useThread;
